import BaseSiteDeviceData from './BaseSiteDeviceData'
import DataFormatter from '../model/DataFormatter'

export default {
  extends: BaseSiteDeviceData,
  data: () => ({
    query: {
      factorIds: []
    },
    unitProp: 'displayUnit',
    selectedNames: [],
    dimension: 0
  }),
  computed: {
    isSetAllFactorIds: () => true,
    isSetUnit: () => false,
    excludeFactorIdMap: () => ({}),
    requiredFactorIds: () => [],
    _filterFactorMap () {
      return this.filterSites.reduce((map, {devices}) => devices.reduce((map, device) => device.siteDeviceFactors.reduce((map, deviceFactor) => {
        let {factorId} = deviceFactor

        if (!map[factorId]) {
          let newDeviceFactor = JSON.parse(JSON.stringify(deviceFactor))
          newDeviceFactor.id = factorId
          map[factorId] = newDeviceFactor
        }

        return map
      }, map), map), {})
    },
    filterFactorMap () {
      return this._filterFactorMap
    },
    filterFactors () {
      return Object.values(this.filterFactorMap).sort((a, b) => a.id - b.id)
    },
    isNoSelectedFactors () {
      return this.query.factorIds.length === 0
    },
    canNotSearch () {
      return this.isNoSelectedSites || this.isNoSelectedFactors
    },
    siteFactorMap () {
      let {filterFactorMap: factorMap, getSeriesParam, getSelectedNames} = this

      return this.filterSites.reduce((map, site) => {
        let siteId = site.id
        let siteConfig = map[siteId] = {
          id: siteId,
          name: site.name,
          map: site.devices.reduce((map, {dataFrequency, maxDelayTime, siteDeviceFactors}) => siteDeviceFactors.reduce((map, deviceFactor) => {
            let {factorId} = deviceFactor
            let factor = factorMap[factorId]

            if (factor) {
              map[factorId] = {
                ...factor,
                dataFrequency,
                maxDelayTime,
                seriesParam: getSeriesParam(0, [siteId, factorId])
              }
            }

            return map
          }, map), {})
        }

        siteConfig.selectedNames = getSelectedNames(0, [siteId, siteConfig.map])

        return map
      }, {})
    },
    factorSiteMap () {
      let {getSeriesParam, getSelectedNames} = this
      let siteFactors = Object.values(this.siteFactorMap)

      return this.filterFactors.reduce((map, factor) => {
        let factorId = factor.id
        let {stdUnit, displayUnit, molecular} = factor
        let sites = siteFactors.filter(site => site.map[factorId])

        if (sites.length > 0) {
          let factorConfig = map[factorId] = {
            id: factorId,
            name: factor.name,
            map: sites.reduce((map, site) => {
              let factor = site.map[factorId]
              let siteId = site.id
              map[siteId] = {
                id: siteId,
                name: site.name,
                stdUnit,
                displayUnit,
                molecular,
                dataFrequency: factor.dataFrequency,
                maxDelayTime: factor.maxDelayTime,
                seriesParam: getSeriesParam(1, [factorId, siteId])
              }
              return map
            }, {})
          }

          factorConfig.selectedNames = getSelectedNames(1, [factorConfig.map, factorId])
        }

        return map
      }, {})
    },
    formatFactorGroupMap () {
      return this.factorGroups.map(factorGroup => ({
        id: factorGroup.id,
        name: factorGroup.name,
        parentId: factorGroup.parentId
      })).reduce((map, factorGroup) => {
        map[factorGroup.id] = factorGroup
        return map
      }, {})
    },
    _factorTree () {
      let filterFactors = JSON.parse(JSON.stringify(this.filterFactors))
      let factorGroupMap = JSON.parse(JSON.stringify(this.formatFactorGroupMap))
      let roots = []

      for (let i = 0; i < filterFactors.length; i++) {
        let factor = filterFactors[i]
        let {parentId} = factor
        let parent = factorGroupMap[parentId]

        if (parent) {
          let {children} = parent

          if (!Array.isArray(children)) {
            children = parent.children = []
            filterFactors.splice(i + 1, 0, parent)
          }

          children.push(factor)
        } else {
          roots.push(factor)
        }
      }

      return roots
    },
    factorTree () {
      return JSON.parse(JSON.stringify(this._factorTree))
    },
    currentFactors () {
      return this.query.siteIds.reduce()
    }
  },
  methods: {
    getFactorTree () {
      return this.$refs['factor-tree']
    },
    _setFactorIds () {
      let {factorTree} = this

      if (factorTree.length > 0) {
        const {isSetAllFactorIds, query} = this
        let tmpList = [factorTree[0]]
        let factorIds = []
        let {unitProp} = this
        let unit

        if (isSetAllFactorIds !== 0) {
          const {excludeFactorIdMap} = this

          for (let i = 0; i < tmpList.length; i++) {
            let config = tmpList[i]
            let {children} = config

            if (Array.isArray(children) && children.length > 0) {
              tmpList.push(...children)
            } else {
              const {id} = config

              if (!excludeFactorIdMap[id]) {
                factorIds.push(id)
                unit = config[unitProp]

                if (isSetAllFactorIds === factorIds.length) {
                  break
                }
              }
            }
          }
        }

        if (this.isSetUnit) {
          query.unit = unit
        }

        query.factorIds = factorIds.concat(this.requiredFactorIds)
      }
    },
    setOther () {
      let {query} = this

      if (!this.factorIdsReady) {
        let {isSetAllFactorIds} = this

        if (isSetAllFactorIds === true) {
          let {filterFactors, excludeFactorIdMap} = this
          query.factorIds = filterFactors.reduce((factorIds, {id}) => {
            if (!excludeFactorIdMap[id]) {
              factorIds.push(id)
            }

            return factorIds
          }, [])

          if (this.isSetUnit) {
            query.unit = this.filterFactors[0] ? this.filterFactors[0][this.unitProp] : ''
          }
        } else {
          this._setFactorIds()
        }

        setTimeout(() => {
          let factorTreeComponent = this.getFactorTree()

          if (factorTreeComponent) {
            factorTreeComponent.setCheckedKeys(query.factorIds)
          }

          query = null
        }, 0)

        this.factorIdsReady = true
      } else {
        let {requiredFactorIds} = this

        if (requiredFactorIds.length > 0) {
          let factorIds = [...query.factorIds]
          let factorIdMap = factorIds.reduce((map, factorId) => {
            map[factorId] = true
            return map
          }, {})

          requiredFactorIds.forEach(factorId => {
            if (!factorIdMap[factorId]) {
              factorIds.push(factorId)
            }
          })

          query.factorIds = factorIds

          if (this.isSetUnit) {
            query.unit = this.filterFactors[0][this.unitProp]
          }
        }
      }

      return query.factorIds.length > 0
    },
    formatData: DataFormatter.format2,
    getSeriesParam (dimension, dimensionIds) {
      return {
        type: 'line',
        showSymbol: false
      }
    },
    getSelectedNames (dimension, params) {
      return null
    },
    onUnitPropChange () {
      this.formatData()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/BaseSiteFactorData.js